/**
 * 권한 판단을 한 곳에 모은다. 서버의 `utils/permission.ts` 와 같은 규칙이다.
 *
 * 직급(`role`)은 **인게임 등급을 따라가는 표시값**이라, 사이트를 굴리는 사람이 게임에서
 * 일반 길드원이면 직급만 보고 막으면 관리 기능을 잃는다. 그래서 `siteAdmin` 을 함께 본다.
 *
 * 화면에서 막는 것은 편의일 뿐이고, 실제 차단은 서버가 한다.
 */

interface Actor {
    role?: string | null;
    siteAdmin?: boolean | null;
}

/** 사이트 운영자인지. 인게임 직급과 무관하게 모든 권한을 갖는다 */
export function isSiteAdmin(user: Actor | null | undefined): boolean {
    return !!user?.siteAdmin;
}

/**
 * 관리 기능(몬스터·게시물·길드원 관리)을 쓸 수 있는지.
 * 마스터·부마스터·선임, 또는 사이트 운영자.
 */
export function isOperator(user: Actor | null | undefined): boolean {
    if (!user) return false;
    if (isSiteAdmin(user)) return true;
    return user.role === 'master' || user.role === 'submaster' || user.role === 'senior';
}

/**
 * 점령전 운영·사이트 설정(카톡 봇 설정 등)을 할 수 있는지 — 마스터·부마스터, 또는 사이트 운영자.
 * 서버 `canManageSiege` 와 같은 규칙이다.
 */
export function canManageSiege(user: Actor | null | undefined): boolean {
    if (!user) return false;
    if (isSiteAdmin(user)) return true;
    return user.role === 'master' || user.role === 'submaster';
}
